import React, {Component} from 'react';
import styles from './PropertyValueLink.scss';
import PropTypes from 'prop-types';
import {trackBannerEvent} from '../../lib/tracking';

class PropertyValueLink extends Component {
  componentDidMount() {
    const {property, isBanner} = this.props;
    trackBannerEvent(property, `PVAU_${isBanner ? 'desktopbanner' : 'sidebanner'}_impression`);
  }

  render() {
    const {property, utm, isBanner} = this.props;

    if (!property.clPropertyId) {
      return null;
    }

    const pvURL =`${process.env.PVAU_URL}/property/${property.address.formattedAddress}/${property.clPropertyId}`
      .replace(/[`,\s]+/g, '-')
      .toLowerCase()
      .concat(`?utm_source=onthehouse&utm_medium=referral&utm_campaign=${utm}`);

    return <div>
      <a className={'gtm-full-history full-history-link ' + (isBanner ? styles.isBanner : '')} href={pvURL} target="_blank"
        rel="nofollow noopener noreferrer" onClick={() => trackBannerEvent(property, `PVAU_click_${isBanner ? 'desktop_banner' : 'sidebanner'}`)}>
        <div className={isBanner ? styles.bannerWrapper : styles.blockWrapper}>
          <div className={'d-flex flex-column ' + styles.blockInfo}>
            <span className={'lgText ' + styles.blockHeader}>
              {isBanner ? <span>See more details on this property</span> : <span>More insights.<br />Smarter decisions</span>}
            </span>
            <span data="seoData">&nbsp;</span>
            <span className={'smText ' + styles.blockDetails}>
              {isBanner ? 'Access the same insights as the big banks' : 'Unlock more details on this property'}
            </span>
          </div>
          <div className={isBanner ? styles.logoDivBanner : styles.logoDivBlock }>
            <img
              className={'p-3 ' + styles.pvLogo}
              src="/assets/images/site-branding/propertyvalue-light.svg"
            />
          </div>
        </div>
      </a>
    </div>;
  }
}

PropertyValueLink.propTypes = {
  property: PropTypes.object.isRequired,
  utm: PropTypes.string.isRequired,
  isBanner: PropTypes.bool
};


export default PropertyValueLink;
